var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_223_11155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 5.52922H11.3333V4.19588C11.3333 2.35588 9.83996 0.862549 7.99996 0.862549C6.15996 0.862549 4.66663 2.35588 4.66663 4.19588V5.52922H3.99996C3.26663 5.52922 2.66663 6.12922 2.66663 6.86255V13.5292C2.66663 14.2625 3.26663 14.8625 3.99996 14.8625H12C12.7333 14.8625 13.3333 14.2625 13.3333 13.5292V6.86255C13.3333 6.12922 12.7333 5.52922 12 5.52922ZM5.99996 4.19588C5.99996 3.08922 6.89329 2.19588 7.99996 2.19588C9.10663 2.19588 9.99996 3.08922 9.99996 4.19588V5.52922H5.99996V4.19588ZM11.3333 13.5292H4.66663C4.29996 13.5292 3.99996 13.2292 3.99996 12.8625V7.52922C3.99996 7.16255 4.29996 6.86255 4.66663 6.86255H11.3333C11.7 6.86255 12 7.16255 12 7.52922V12.8625C12 13.2292 11.7 13.5292 11.3333 13.5292ZM7.99996 11.5292C8.73329 11.5292 9.33329 10.9292 9.33329 10.1959C9.33329 9.46255 8.73329 8.86255 7.99996 8.86255C7.26663 8.86255 6.66663 9.46255 6.66663 10.1959C6.66663 10.9292 7.26663 11.5292 7.99996 11.5292Z",
    fill: "#123051"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_223_11155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.195923)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.fba83f6a599b0c5c33836256e29921f0.svg";
export { ForwardRef as ReactComponent };